<template>
  <div class="media-export">
    <transition
      enter-from-class="opacity-0"
      leave-to-class="opacity-0"
      enter-active-class="export-transition"
      leave-active-class="export-transition"
      mode="out-in"
    >
      <component
        :is="currentComponent"
        v-bind="{ options: options, returnUTC, downloadLink: exportLink, usePeriod }"
        @select="handleSelect"
        @closeModal="closeModal"
      />
    </transition>
  </div>
</template>
<script>
import SelectExportType from '@/components/custom/modals/export/components/selectExportType.vue'
import ExportLoader from '@/components/custom/modals/export/components/exportLoader.vue'
import DownloadExport from '@/components/custom/modals/export/components/downloadExport.vue'

export default {
  name: 'exportMediaModal',
  props: {
    options: {
      type: Array,
      required: true,
    },
    usePeriod: {
      type: Boolean,
      default: false,
    },
    startExport: {
      type: Function,
      required: true,
    },
    checkExport: {
      type: Function,
      required: true,
    },
    returnUTC: {
      type: Boolean,
      default: false,
    },
  },
  components: { SelectExportType, ExportLoader, DownloadExport },
  data: () => ({
    loading: false,
    currentComponent: 'SelectExportType',
    selectedExportType: '',
    selectedPeriod: null,
    exportLink: '',
  }),
  computed: {},
  methods: {
    closeModal() {
      this.$emit('close')
    },
    async checkExportStatus() {
      if (!this.checkExport) {
        return
      }

      try {
        const response = await this.checkExport(this.selectedExportType, this.selectedPeriod)
        if (response?.data?.data?.link) {
          this.exportLink = response.data.data.link
          this.currentComponent = 'DownloadExport'
        } else {
          setTimeout(() => {
            this.checkExportStatus()
          }, 5000)
        }
      } catch (e) {
        const errorMessage =
          e.response?.data?.error ||
          'Something went wrong while exporting media'
        console.log(errorMessage)
      }
    },
    async handleSelect(options) {
      if (!this.startExport) {
        return
      }

      const { type, period } = options

      this.selectedExportType = type
      this.selectedPeriod = { ...period }

      try {
        const response = await this.startExport(this.selectedExportType, this.selectedPeriod)
        if (response?.data?.data?.message === 'File generation started') {
          this.checkExportStatus()
          this.currentComponent = 'ExportLoader'
        } else {
          // eslint-disable-next-line no-throw-literal
          throw { response }
        }
      } catch (e) {
        const errorMessage = e.response?.data?.error?.message
        if (errorMessage === 'Export already in process') {
          this.checkExportStatus()
          this.currentComponent = 'ExportLoader'
        } else {
          this.$notification.error({
            message: 'Error while exporting',
            description: errorMessage,
          })
        }
      }
    },
  },
}
</script>

<style lang="scss">
.media-export {
  &__radio {
    display: block !important;
    height: 30px;
    line-height: 30px;
  }
  .opacity-0 {
    opacity: 0;
  }
  .export-transition {
    transition-property: color, background-color, border-color,
      text-decoration-color, fill, stroke, opacity, box-shadow, transform,
      filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
  }
}
</style>
